import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import {
	useGetCurrentBreakpoint,
	useGetValueByCreditType,
	useGtm,
	useHideScroll,
	useIsVisibleModal,
	useModal,
	useRedirectWithContext,
} from '@hooks';
import { useFetchGetQRCodeAndLink } from '@services';
import { useLoadingStore, useSessionInfo } from '@store';
import { BaseSessionInfoCompany } from '@types';

export interface UserIsClientHelperOutput {
	handleOnClickClose: () => void;
	handleYesButton: () => void;
	handleClickGetInTouch: () => void;
	isVisible: boolean;
	currentView: string;
	translate: (key: string) => string;
}

export const useUserIsClientHelper = () => {
	const sessionInfo = useSessionInfo();
	const { currentView } = useGetCurrentBreakpoint();
	const { hide: hideUserIsClientModal } = useModal('userIsClient');
	const translate = useTranslation();
	const { enable: enableScroll } = useHideScroll();
	const isVisible = useIsVisibleModal('userIsClient');

	const { setIsLoadingQRCodeAndLink } = useLoadingStore();
	const { fetch: fetchGetQRCodeAndLink } = useFetchGetQRCodeAndLink();
	const { show: showAutoSimulate } = useModal('autoSimulate');
	const isAb = sessionInfo?.company === BaseSessionInfoCompany.AB;
	const creditType = sessionInfo?.journeyData.loanType || 'AL';
	const { sendEvent } = useGtm();

	const { navigate } = useRedirectWithContext();

	// cSpell: disable
	const itemType = useGetValueByCreditType(
		{
			CL: 'credito-pessoal',
			AL: 'credito-auto',
			RENEN: 'credito-edificios-sustentaveis',
			ALEV: 'credito-eletricauto',
			HOME: 'credito-lar',
			AN: 'credito-auto-novos',
			CONSTR: 'credito-obras',
			EDUCA: 'credito-educacao',
			HEALTH: 'credito-saude',
		},
		'credito-pessoal'
	);
	// cSpell: enable

	const handleOnClickClose = () => {
		sendEvent({
			// cSpell:disable
			eName: 'fechar',
			screen_name: `${itemType}/simulador-publico/modal-confirmar-avancar`,
			// cSpell:enable
		});
		hideUserIsClientModal();
		enableScroll();
	};

	const handleYesButton = () => {
		sendEvent({
			// cSpell:disable
			eName: 'continuar-app',
			screen_name: `${itemType}/simulador-publico/modal-confirmar-avancar`,
			// cSpell:enable
		});
		setIsLoadingQRCodeAndLink(true);
		if (isAb) {
			handleOnClickClose();
			fetchGetQRCodeAndLink({});
			showAutoSimulate();
			return;
		}

		// navigate({
		// 	amount: sessionInfo?.journeyData.amount || 0,
		// 	term: sessionInfo?.journeyData.term || 0,
		// 	callback: () => {
		// 		setIsLoadingQRCodeAndLink(false);
		// 	},
		// });
		const url = translate(`simulator.dataDisplay.nextButton.link.${creditType}`);
		window.open(url, '_self');
	};

	const handleClickGetInTouch = () => {
		sendEvent(
			{
				// cSpell:disable
				eName: 'nao-sou-cliente-pedir-contacto',
				screen_name: `${itemType}/simulador-publico/modal-confirmar-avancar`,
				// cSpell:enable
			},
			true
		);
		if (isAb) {
			window.ReactWidgetsContactHub.api.showContactHubContent();
		} else {
			const url = translate('simulator.modals.userIsClient.url.generalContacts');
			window.open(url, '_self');
		}
		hideUserIsClientModal();
		enableScroll();
	};

	return {
		handleOnClickClose,
		handleYesButton,
		handleClickGetInTouch,
		isVisible,
		currentView,
		translate,
	};
};
